import {
  TypographyT14,
  TypographyT15,
  TypographyT16,
  TypographyT17,
} from "Components/Common/Typography/index";
import React, { Component, Fragment } from "react";
import styled from "@emotion/styled/macro";
import { Spacer } from "Components/Common/Spacer/index";
import RateInfoCard from "./RateInfoCard";
import Message from "Components/Common/Message/Message";
import { getToFixedValue } from "Utils/index";
class RateComparisonTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      demoData: [
        {
          routesDetail: "Mundra - Lucknow",
          roadFreight: {
            rate: "",
            labelL: "",
            isNA: true,
            isActve: false,
          },
          railFreight: {
            rate: "",
            labelL: "",
            isNA: true,
            isActve: false,
          },
          railContainerFrt: {
            rate: "",
            labelL: "",
            isNA: true,
            isActve: false,
          },
          coastalFreight: {
            rate: "6000",
            labelL: "L6",
            isNA: false,
            isActve: false,
          },
          riverFreight: {
            rate: "",
            labelL: "",
            isNA: true,
            isActve: false,
          },
        },
        {
          routesDetail: "Alwar - Lucknow",
          roadFreight: {
            rate: "5782",
            labelL: "L5",
            isNA: false,
            isActve: false,
          },
          railFreight: {
            rate: "4217",
            labelL: "L1",
            isNA: false,
            isActve: true,
          },
          railContainerFrt: {
            rate: "5202",
            labelL: "L4",
            isNA: false,
            isActve: false,
          },
          coastalFreight: {
            rate: "4466",
            labelL: "L2",
            isNA: false,
            isActve: false,
          },
          riverFreight: {
            rate: "",
            labelL: "",
            isNA: true,
            isActve: false,
          },
        },
        {
          routesDetail: "Bundi - Lucknow",
          roadFreight: {
            rate: "",
            labelL: "",
            isNA: true,
            isActve: false,
          },
          railFreight: {
            rate: "4700",
            labelL: "L3",
            isNA: false,
            isActve: false,
          },
          railContainerFrt: {
            rate: "",
            labelL: "",
            isNA: true,
            isActve: false,
          },
          coastalFreight: {
            rate: "",
            labelL: "",
            isNA: true,
            isActve: false,
          },
          riverFreight: {
            rate: "",
            labelL: "",
            isNA: true,
            isActve: false,
          },
        },
        {
          routesDetail: "Hazira - Lucknow",
          roadFreight: {
            rate: "",
            labelL: "",
            isNA: true,
            isActve: false,
          },
          railFreight: {
            rate: "",
            labelL: "",
            isNA: true,
            isActve: false,
          },
          railContainerFrt: {
            rate: "",
            labelL: "",
            isNA: true,
            isActve: false,
          },
          coastalFreight: {
            rate: "",
            labelL: "",
            isNA: true,
            isActve: false,
          },
          riverFreight: {
            rate: "",
            labelL: "",
            isNA: true,
            isActve: false,
          },
        },
      ],
    };
  }
  render() {
    const {
      handleOnClickForRateComparisonTableItems,
      roadFreight,
      railFreightBcn,
      handleOnClickForVehicleName
    } = this.props;
    const { demoData } = this.state;
    return (
      <Fragment>
        {roadFreight.length === 0 && <Message />}
        <RateComparisonTableWrapper>
          {roadFreight.length !== 0 && (
            <Table>
              <THead>
                <Tr>
                  <Th></Th>
                  {roadFreight.map((ele, ind) => {
                    return (
                      <Fragment key={ind}>
                        <Th>
                          <TypographyT15
                            style={{}}
                          >{`${ele.from} - ${ele.to}`}</TypographyT15>
                        </Th>
                      </Fragment>
                    );
                  })}
                </Tr>
              </THead>
              <TBody>
                <Tr>
                  <Td>
                    <TypographyT16 style={{ width: "max-content" }}>
                      ROAD FREIGHT
                    </TypographyT16>
                  </Td>
                  {roadFreight.map((ele, ind) => {
                    const { rate_order_text, sum_of_bid_price } = ele;
                    const isNA = false;
                    return (
                      <Fragment key={ind}>
                        {isNA ? (
                          <Fragment>
                            <Td>
                              <TypographyT17>NA</TypographyT17>
                            </Td>
                          </Fragment>
                        ) : (
                          <Fragment>
                            <Td
                                onClick={
                                  () => {
                                    handleOnClickForVehicleName(ele)
                                  }
                                }
                            >
                              <RateInfoCard
                                rate={getToFixedValue(sum_of_bid_price,2)}
                                labelOfL={rate_order_text}
                                isActive={false}
                                isLActive={rate_order_text === "L1"}
                              />
                            </Td>
                          </Fragment>
                        )}
                      </Fragment>
                    );
                  })}
                </Tr>
                <Tr>
                  <Td>
                    <TypographyT16 style={{ width: "max-content" }}>
                      RAIL FREIGHT BCN(Full Rake)
                    </TypographyT16>
                  </Td>

                  {railFreightBcn.map((ele, ind) => {
                    const { rate_order_text, sum_of_bid_price } = ele;
                    const isNA = rate_order_text === "NA" ? true : false;
                    return (
                      <Fragment key={ind}>
                        {isNA ? (
                          <Fragment>
                            <Td>
                              <TypographyT17>NA</TypographyT17>
                            </Td>
                          </Fragment>
                        ) : (
                          <Fragment>
                            <Td
                              onClick={() => {
                                handleOnClickForRateComparisonTableItems(ele);
                              }}
                            >
                              <RateInfoCard
                                rate={getToFixedValue(sum_of_bid_price,2)}
                                labelOfL={rate_order_text}
                                isActive={false}
                                isLActive={rate_order_text === "L1"}
                              />
                            </Td>
                          </Fragment>
                        )}
                      </Fragment>
                    );
                  })}
                </Tr>
                {/* <Tr>
                <Td>
                  <TypographyT16>RAIL CONTAINER FRT.</TypographyT16>
                </Td>

                {demoData.map((ele, ind) => {
                  const { rate, labelL, isNA, isActve } = ele.railContainerFrt;
                  return (
                    <Fragment key={ind}>
                      {isNA ? (
                        <Fragment>
                          <Td>
                            <TypographyT17>NA</TypographyT17>
                          </Td>
                        </Fragment>
                      ) : (
                        <Fragment>
                          <Td
                            onClick={handleOnClickForRateComparisonTableItems}
                          >
                            <RateInfoCard
                              rate={rate}
                              labelOfL={labelL}
                              isActive={isActve}
                              isLActive={labelL === "L1"}
                            />
                          </Td>
                        </Fragment>
                      )}
                    </Fragment>
                  );
                })}

              
              </Tr> */}
                {/* <Tr>
                <Td>
                  <TypographyT16>COASTAL FREIGHT</TypographyT16>
                </Td>

                {demoData.map((ele, ind) => {
                  const { rate, labelL, isNA, isActve } = ele.coastalFreight;
                  return (
                    <Fragment key={ind}>
                      {isNA ? (
                        <Fragment>
                          <Td>
                            <TypographyT17>NA</TypographyT17>
                          </Td>
                        </Fragment>
                      ) : (
                        <Fragment>
                          <Td
                            onClick={handleOnClickForRateComparisonTableItems}
                          >
                            <RateInfoCard
                              rate={rate}
                              labelOfL={labelL}
                              isActive={isActve}
                              isLActive={labelL === "L1"}
                            />
                          </Td>
                        </Fragment>
                      )}
                    </Fragment>
                  );
                })}
             
              </Tr> */}
                {/* <Tr>
                <Td>
                  <TypographyT16>RIVER FREIGHT</TypographyT16>
                </Td>
                {demoData.map((ele, ind) => {
                  const { rate, labelL, isNA, isActve } = ele.riverFreight;
                  return (
                    <Fragment key={ind}>
                      {isNA ? (
                        <Fragment>
                          <Td>
                            <TypographyT17>NA</TypographyT17>
                          </Td>
                        </Fragment>
                      ) : (
                        <Fragment>
                          <Td
                            onClick={handleOnClickForRateComparisonTableItems}
                          >
                            <RateInfoCard
                              rate={rate}
                              labelOfL={labelL}
                              isActive={isActve}
                              isLActive={labelL === "L1"}
                            />
                          </Td>
                        </Fragment>
                      )}
                    </Fragment>
                  );
                })}
             
              </Tr> */}
              </TBody>
            </Table>
          )}
        </RateComparisonTableWrapper>
      </Fragment>
    );
  }
}

export default RateComparisonTable;

const RateComparisonTableWrapper = styled.div`
  overflow: auto;
`;

const Table = styled("table")`
  width: 100%;
  border-collapse: collapse;
  border-radius: 5px;
  box-shadow: 0px 0px 2px 1px #d1d1d1;
`;

const Th = styled("th")`
  padding: 10px;
  background-color: #e7edfa;
  text-align: left;
`;

const THead = styled("thead")`
  & ${Th}:last-of-type {
    border-top-right-radius: 5px;
  }
  & ${Th}:first-of-type {
    border-top-left-radius: 5px;
  }
`;
const TBody = styled("tbody")``;
const Td = styled("td")`
  padding: 10px;
  background-color: #ffffff;
  border-bottom: 1px solid rgba(82, 138, 234, 0.45);
  cursor: pointer;
  &:not(:first-child):hover {
    background-color: #d9e7ff;
  }
`;
const Tr = styled("tr")`
  &:last-of-type ${Td} {
    border-bottom: 0px;
  }
  &:last-of-type ${Td}:last-of-type {
    border-bottom-right-radius: 5px;
  }
  &:last-of-type ${Td}:first-of-type {
    border-bottom-left-radius: 5px;
  }
`;
